import { ChangeEvent, FC, useEffect, useState } from 'react'
import * as Yup from 'yup'
import { useFormik } from 'formik'
import { isNotEmpty, toAbsoluteUrl } from '../../../../../_metronic/helpers'
import { initialHawala, Hawala } from '../core/_models'
import clsx from 'clsx'
import { useListView } from '../core/ListViewProvider'
import { HawalasListLoading } from '../components/loading/HawalasListLoading'
import { createHawala, updateHawala } from '../core/_requests'
import { useQueryResponse } from '../core/QueryResponseProvider'
import { FormattedMessage, useIntl } from 'react-intl'
import { Company, Service } from '../../../service/services-list/core/_models'
import { ServiceCategory } from '../../../service-category/service-categories-list/core/_models'

type Props = {
  isHawalaLoading: boolean
  hawala: Hawala
}

const editHawalaSchema = Yup.object().shape({
  profile_image_url: Yup.mixed(),
})

const HawalaEditModalForm: FC<Props> = ({ hawala, isHawalaLoading }) => {
  const intl = useIntl()
  // Function to handle image selection
  const [selectedImage, setSelectedImage] = useState<string | null>(null);

  // Function to handle image selection
  const handleImageChange = (event: ChangeEvent<HTMLInputElement>) => {
    if (event.target.files && event.target.files.length > 0) {
      const file = event.target.files[0];
      const imageURL = URL.createObjectURL(file);
      setSelectedImage(imageURL);

    }
  };

  const { setItemIdForUpdate } = useListView()
  const { refetch } = useQueryResponse()
  const [companies, setCompanies] = useState<[Company]>();
  const [services, setServices] = useState<[Service]>();
  const [hawalaForEdit] = useState<Hawala>({
    ...hawala,
    id: hawala.id || initialHawala.id,
    rechargeble_account: hawala.rechargeble_account || initialHawala.rechargeble_account,
    // hawala_description: hawala.hawala_description || initialHawala.hawala_description,
    // hawala_code: hawala.hawala_code || initialHawala.hawala_code,
    // buying_price: hawala.buying_price || initialHawala.buying_price,
    // selling_price: hawala.selling_price || initialHawala.selling_price,
    // currency_id: hawala.currency_id || initialHawala.currency_id,
    // hawala_image_url: hawala.hawala_image_url || initialHawala.hawala_image_url,
    // service: hawala.service?.id || initialHawala.service?.id,
    // service_id:hawala.service_id || initialHawala.service_id

  })

  const cancel = (withRefresh?: boolean) => {
    if (withRefresh) {
      refetch()
    }
    setItemIdForUpdate(undefined)
  }

  const formik = useFormik({
    initialValues: hawalaForEdit,
    validationSchema: editHawalaSchema,
    onSubmit: async (values, { setSubmitting }) => {
      console.log("form values", values);
      setSubmitting(true)
      try {
        if (isNotEmpty(values.id)) {
          await updateHawala(values)
        } else {
          await createHawala(values)
        }
      } catch (ex) {
        console.error(ex)
      } finally {
        setSubmitting(true)
        cancel(true)
      }
    },
  })

  return (
    <>
      <form id='kt_modal_add_hawala_form' encType="multipart/form-data" className='form' onSubmit={formik.handleSubmit} noValidate>
        {/* begin::Scroll */}
        <div
          className='d-flex flex-column scroll-y me-n7 pe-7'
          id='kt_modal_add_hawala_scroll'
          data-kt-scroll='true'
          data-kt-scroll-activate='{default: false, lg: true}'
          data-kt-scroll-max-height='auto'
          data-kt-scroll-dependencies='#kt_modal_add_hawala_header'
          data-kt-scroll-wrappers='#kt_modal_add_hawala_scroll'
          data-kt-scroll-offset='300px'
        >
          {/* begin::Input group */}

          {/* end::Input group */}
          {/* begin::Input group */}
          <div className='fv-row mb-7'>
            {/* begin::Label */}
            <label className='required fw-bold fs-6 mb-2'><FormattedMessage id='HAWALA.FORM.INPUT.HAWALATITLE' />
            </label>
            {/* end::Label */}

            {/* begin::Input */}
            <input
              placeholder={intl.formatMessage({ id: 'HAWALA.FORM.PLACEHOLDER.HAWALATITLE' })}
              {...formik.getFieldProps('rechargeble_account')}
              className={clsx(
                'form-control form-control-solid mb-3 mb-lg-0',
                { 'is-invalid': formik.touched.rechargeble_account && formik.errors.rechargeble_account },
                {
                  'is-valid': formik.touched.rechargeble_account && !formik.errors.rechargeble_account,
                }
              )}
              type='text'
              name='rechargeble_account'
              autoComplete='off'
              disabled={formik.isSubmitting || isHawalaLoading}
            />
            {/* end::Input */}
            {formik.touched.rechargeble_account && formik.errors.rechargeble_account && (
              <div className='fv-plugins-message-container'>
                {/* <span role='alert'>{formik.errors.language_id}</span> */}
              </div>
            )}
          </div>
          {/* end::Input group */}
  

        </div>
        {/* end::Scroll */}

        {/* begin::Actions */}
        <div className='text-center pt-15'>
          <button
            type='reset'
            onClick={() => cancel()}
            className='btn btn-light me-3'
            data-kt-hawalas-modal-action='cancel'
            disabled={formik.isSubmitting || isHawalaLoading}
          >
            <FormattedMessage id='FORM.GENERAL.DISCARD' />
          </button>

          <button
            type='submit'
            className='btn btn-primary'
            data-kt-hawalas-modal-action='submit'
            disabled={isHawalaLoading || formik.isSubmitting || !formik.isValid || !formik.touched}
          >
            <span className='indicator-label'>Submit</span>
            {(formik.isSubmitting || isHawalaLoading) && (
              <span className='indicator-progress'>
                <FormattedMessage id='FORM.GENERAL.PLEASEWAIT' />
                {' '}
                <span className='spinner-bhawala spinner-bhawala-sm align-middle ms-2'></span>
              </span>
            )}
          </button>
        </div>
        {/* end::Actions */}
      </form>
      {(formik.isSubmitting || isHawalaLoading) && <HawalasListLoading />}
    </>
  )
}

export { HawalaEditModalForm }
